import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import './assets/css/index.css';
// import 'element-ui/lib/theme-chalk/index.css';
import AxiosPlugin from './plugin/AxiosPlugin';
import Config from './config/app';
import 'font-awesome/css/font-awesome.css';
import Function from './config/function';
import Untils from './config/untils';

// 是否显示出消息提示 （开发阶段开启，部署线上关闭）
Vue.config.productionTip = true;

// Vue.use(AxiosPlugin);
Vue.use(ElementUI);
Vue.use(Function);
Vue.use(Untils);

Vue.prototype.$Config = Config;
Vue.prototype.$http = AxiosPlugin;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
